module.exports = __webpack_public_path__ + "images/pages/for_business/sp/s_icon02_f8ad23b0dd13352f203ca22956abf934.png";